module.exports = __webpack_public_path__ + "img/bulb-alert.31a77ca5.svg";